import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-footer-promo]',
};

const classes = {
  swiperPagination: '.footer-promo-swiper-pagination',
};

class FooterPromo extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousel();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousel() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: classes.swiperPagination,
        clickable: true,
      },
      autoplay: {
        // reverseDirection: true,
        delay: 3000,
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          loop: false,
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.carousel.destroy(true, true);
      this.initCarousel();
    });
  }
}

customElements.define('footer-promo', FooterPromo);
